// extracted by mini-css-extract-plugin
export var actualiteContentFooter = "detailsActu-module--actualite-content-footer--50f56";
export var actualiteContentFooterBack = "detailsActu-module--actualite-content-footer-back--d3cbc";
export var actualiteImg = "detailsActu-module--actualite-img--9913c";
export var actualiteTitle = "detailsActu-module--actualite-title--434b1";
export var editButton = "detailsActu-module--edit-button--cc202";
export var gridAriane = "detailsActu-module--grid-ariane--072f2";
export var gridContent = "detailsActu-module--grid-content--a6054";
export var gridDate = "detailsActu-module--grid-date--fb955";
export var gridResume = "detailsActu-module--grid-resume--92504";
export var gridTags = "detailsActu-module--grid-tags--25996";
export var gridTitle = "detailsActu-module--grid-title--5db10";
export var pageActu = "detailsActu-module--page-actu--e26b9";
export var pageActuAdditionalInfos = "detailsActu-module--page-actu-additional-infos--07c3e";